export default __webpack_public_path__ + "static/media/landrover.f85260c7.jpeg";